import React, { useEffect, useRef, useState } from "react";
import {
  CustomButton,
  CustomDialog,
  CustomIconButton,
} from "../../../../../../../../Components";
import ImagePublishDetailsComponent from "../ImagePublishDetailsComponent/ImagePublishDetailsComponent";
import {
  useQuery,
  useSelectedTheme,
  useTranslate,
} from "../../../../../../../../Hooks";
import { Box } from "@material-ui/core";
import { getDownloadableLink } from "../../../../../../../../Helper";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
import {
  CreateOrUpdateUnitImageInfo,
  CreateOrUpdateUnitImageInfoproperty,
} from "../../../../../../../../Services";

// styles
import useStyles from "./styles";

// icons
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { Download01 } from "../../../../../../../../assets/icons";

function PropertyImagePreviewDialog({ onOpen, onClose, data, activeImage }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { setAlertBoxContent } = useVerticalNav();
  const query = useQuery();
  const imageRef = useRef(null);
  const thumbnailsRef = useRef(null);
  const [imageUrl, setImageUrl] = useState(null);
  const validImages = data?.images?.result?.filter((v) => v.fileId);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const pathName = window.location.pathname
    .split("/home/")[1]
    .split("/view")[0];
  const defaultData = {
    categoryId: (data && data.categoryId) || null,
    fileId: (activeImage && activeImage.fileId) || null,
    fileName: (activeImage && activeImage.fileName) || null,
    unitId: (data && data.unitId) || query.get("id"),
    imageTitle: null,
    imageDescription: null,
    isPublished: false,
    isNeedOwnerApproval: false,
    isApproved: false,
    approveOwnerId: null,
    approvedById: null,
    approvalDate: null,
    isMarketing: false,
    comments: null,
  };
  const [state, setstateData] = useState({
    categoryId: (data && data.categoryId) || null,
    fileId: (data && data.fileId) || null,
    fileName: (data && data.fileName) || null,
    unitId: (data && data.unitId) || query.get("id"),
    imageTitle: null,
    imageDescription: null,
    isPublished: false,
    isNeedOwnerApproval: false,
    isApproved: false,
    approveOwnerId: null,
    approvedById: null,
    approvalDate: null,
    comments: null,
    isMarketing: false,
  });

  const handleSavePublishImageInfo = async () => {
    const res =
      pathName === "Properties-CRM/property-profile-overview"
        ? await CreateOrUpdateUnitImageInfoproperty(state)
        : await CreateOrUpdateUnitImageInfo(state);
    if (!(res && res.status && res.status !== 200)) {
      setAlertBoxContent({
        display: true,
        variant: "success",
        title: translate("Info-add-successfully"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
      onClose();
    } else
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("failed-add-Info"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
  };

  const handleSelectImage = (video, index) => {
    setSelectedImage(video);
    setSelectedImageIndex(index);
  };

  const handleScroll = (direction) => {
    const container = thumbnailsRef.current;
    if (!container) return;

    const scrollAmount = 120 * 3;
    container.scrollBy({
      left: direction === "right" ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  };

  const downloadDocument = (item) => {
    if (!item) {
      return;
    }
    try {
      const link = document.createElement("a");
      link.setAttribute("download", item.fileName);
      link.href = getDownloadableLink(item.fileId);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  useEffect(() => {
    if (validImages?.length > 0) {
      const initialIndex = activeImage
        ? validImages.findIndex((v) => v.fileId === activeImage.fileId)
        : 0;

      setSelectedImage(validImages[initialIndex >= 0 ? initialIndex : 0]);
      setSelectedImageIndex(initialIndex >= 0 ? initialIndex : 0);
    }
  }, [data, activeImage]);

  useEffect(() => {
    if (selectedImage?.fileId) {
      const url = getDownloadableLink(selectedImage.fileId);
      setImageUrl(url);
    } else {
      setImageUrl(null);
    }
  }, [selectedImage]);

  useEffect(() => {
    if (imageRef.current) {
      imageRef.current.load();
    }
  }, [imageUrl]);

  return (
    <CustomDialog
      open={onOpen}
      onClose={() => {
        onClose();
      }}
      title={translate("Preview-Image")}
      subtitle={translate("View-and-edit-attach-files")}
      cancelText={translate("Discard")}
      confirmText={translate("Save-changes")}
      onConfirm={() => {
        handleSavePublishImageInfo();
      }}
      contentDialogClass={styles.containerContentDialog}
      width={"1024px"}
      content={
        <Box className={styles.wrapperPreview}>
          <Box className={styles.containerItems}>
            {" "}
            <Box className={styles.containerMainItem}>
              <img
                alt="ImageProperty"
                src={imageUrl}
                style={{ width: "100%", height: "100%", borderRadius: "6px" }}
              />
            </Box>
            <Box className={styles.containerSubItemsSection}>
              <Box className={styles.containerNextPrevButton}>
                <CustomIconButton
                  variant="text"
                  size="xs"
                  boxShadow="none"
                  color="secondary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleScroll("left");
                  }}
                >
                  <ChevronLeft
                    width="20"
                    height="20"
                    fill={palette.foreground.quarterary}
                  />
                </CustomIconButton>
              </Box>

              <Box
                className={styles.videoThumbnailsContainer}
                ref={thumbnailsRef}
              >
                {data?.images?.result?.map((img, index) => (
                  <Box
                    key={img.fileId}
                    className={styles.videoThumbnailWrapper}
                    onClick={() => handleSelectImage(img, index)}
                    sx={{
                      border:
                        index === selectedImageIndex
                          ? `2px solid ${palette.button.primary_bg}`
                          : "2px solid transparent",
                      borderRadius: "6px",
                      overflow: "hidden",
                      cursor: "pointer",
                      flex: "0 0 auto",
                    }}
                  >
                    <img
                      src={getDownloadableLink(img.fileId)}
                      alt="ImageProperty"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Box>
                ))}
              </Box>

              <Box className={styles.containerNextPrevButton}>
                <CustomIconButton
                  variant="text"
                  size="xs"
                  boxShadow="none"
                  color="secondary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleScroll("right");
                  }}
                >
                  <ChevronRight
                    width="20"
                    height="20"
                    fill={palette.foreground.quarterary}
                  />
                </CustomIconButton>
              </Box>
            </Box>
          </Box>
          <ImagePublishDetailsComponent
            activeImage={selectedImage}
            setstateData={setstateData}
            state={state}
            data={data}
            defaultData={defaultData}
          />
        </Box>
      }
      moreAction={
        <CustomButton
          boxShadow="none"
          size="lg"
          variant="text"
          color="tertiaryGray"
          startIcon={
            <Download01
              width="20"
              height="20"
              fill={palette.button.tertiaryGray_fg}
            />
          }
          onClick={() => {
            downloadDocument(selectedImage);
          }}
          style={{ marginInlineEnd: "auto" }}
        >
          {translate("Download")}
        </CustomButton>
      }
    ></CustomDialog>
  );
}

export default PropertyImagePreviewDialog;
